module.exports = __webpack_public_path__ + "img/c01_unitstartechstrongholdtower_Normal_ua.8d62a251.webp";